// src/pages/admin/AdminLog.js
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import AdminLayout from "../../components/admin/AdminLayout";

const API_URL = process.env.REACT_APP_API_URL || "https://crm-backend-5tk6.onrender.com";

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  font-size: 0.83rem;
`;

const Th = styled.th`
  background: #f9f9f9;
  padding: 11px 14px;
  text-align: left;
  color: #555;
  font-weight: 600;
  border-bottom: 1px solid #eee;
`;

const Td = styled.td`
  padding: 10px 14px;
  border-bottom: 1px solid #f0f0f0;
  color: #333;
`;

const Badge = styled.span`
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  background: ${p => {
    if (p.accion === "ELIMINAR") return "#fdecea";
    if (p.accion === "CREAR") return "#e8f5e9";
    if (p.accion === "EDITAR") return "#e3f2fd";
    if (p.accion === "CARGA_MASIVA") return "#fff8e1";
    return "#f5f5f5";
  }};
  color: ${p => {
    if (p.accion === "ELIMINAR") return "#c8102e";
    if (p.accion === "CREAR") return "#2e7d32";
    if (p.accion === "EDITAR") return "#1565c0";
    if (p.accion === "CARGA_MASIVA") return "#e65100";
    return "#555";
  }};
`;

const Empty = styled.p`color: #aaa; text-align: center; padding: 32px; font-size: 0.9rem;`;

export default function AdminLog() {
  const [log, setLog] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("admin_token");

  useEffect(() => {
    fetch(`${API_URL}/api/admin/log`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(r => r.json())
      .then(setLog)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [token]);

  const formatFecha = (f) => {
    if (!f) return "—";
    return new Date(f).toLocaleString("es-MX", {
      day: "2-digit", month: "short", year: "numeric",
      hour: "2-digit", minute: "2-digit"
    });
  };

  return (
    <AdminLayout titulo="Log de actividad">
      {loading ? (
        <Empty>Cargando...</Empty>
      ) : log.length === 0 ? (
        <Empty>Sin actividad registrada.</Empty>
      ) : (
        <Table>
          <thead>
            <tr>
              <Th>Fecha</Th>
              <Th>Usuario</Th>
              <Th>Acción</Th>
              <Th>Tipo</Th>
              <Th>Referencia</Th>
            </tr>
          </thead>
          <tbody>
            {log.map((item, i) => (
              <tr key={i}>
                <Td>{formatFecha(item.fecha)}</Td>
                <Td>{item.usuario}</Td>
                <Td><Badge accion={item.accion}>{item.accion.replace("_", " ")}</Badge></Td>
                <Td>{item.tipo}</Td>
                <Td>{item.referencia}</Td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </AdminLayout>
  );
}
